import { c as _c } from "react/compiler-runtime";
import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import { useEffect } from 'react';
import useMetaFormattedCityStateZip from '../useMetaFormattedCityStateZip';
const DEFAULT_BASIC_DETAILS = {};
const DEFAULT_VARIANT_SKU = '';
const useJbEventFBViewPDP = t0 => {
  const $ = _c(13);
  const {
    basicDetails: t1,
    selectedOptionsVariantSku: t2
  } = t0;
  const basicDetails = t1 === undefined ? DEFAULT_BASIC_DETAILS : t1;
  const selectedOptionsVariantSku = t2 === undefined ? DEFAULT_VARIANT_SKU : t2;
  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state
  } = useMetaFormattedCityStateZip();
  let t3;
  if ($[0] !== basicDetails || $[1] !== city || $[2] !== selectedOptionsVariantSku || $[3] !== state || $[4] !== zip) {
    t3 = () => {
      const sku = basicDetails?.sku ? basicDetails.sku + selectedOptionsVariantSku : null;
      if (basicDetails?.sku && basicDetails.name) {
        window.jbEventFBViewPDP = () => {
          sendFBEvent(FB_EVENTS.VIEW_PDP, {
            content_ids: [sku],
            content_name: basicDetails.name,
            content_type: "product",
            zp: zip,
            ct: city,
            st: state
          });
        };
      } else {
        window.jbEventFBViewPDP = undefined;
      }
    };
    $[0] = basicDetails;
    $[1] = city;
    $[2] = selectedOptionsVariantSku;
    $[3] = state;
    $[4] = zip;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = basicDetails?.name;
  const t5 = basicDetails?.sku;
  let t6;
  if ($[6] !== city || $[7] !== selectedOptionsVariantSku || $[8] !== state || $[9] !== t4 || $[10] !== t5 || $[11] !== zip) {
    t6 = [t4, t5, city, selectedOptionsVariantSku, state, zip];
    $[6] = city;
    $[7] = selectedOptionsVariantSku;
    $[8] = state;
    $[9] = t4;
    $[10] = t5;
    $[11] = zip;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t3, t6);
};
export default useJbEventFBViewPDP;